/** Minimal structured logger for conveyor-agent (writes to stderr). */
export function createServiceLogger(service: string) {
  const prefix = `[conveyor-agent:${service}]`;
  return {
    info(message: string, data?: Record<string, unknown>): void {
      const extra = data ? ` ${JSON.stringify(data)}` : "";
      process.stderr.write(`${prefix} ${message}${extra}\n`);
    },
    warn(message: string, data?: Record<string, unknown>): void {
      const extra = data ? ` ${JSON.stringify(data)}` : "";
      process.stderr.write(`${prefix} WARN ${message}${extra}\n`);
    },
    error(message: string, data?: Record<string, unknown>): void {
      const extra = data ? ` ${JSON.stringify(data)}` : "";
      process.stderr.write(`${prefix} ERROR ${message}${extra}\n`);
    },
  };
}
